// extracted by mini-css-extract-plugin
export default {"Badge":"Badge-module--Badge--YPeQX","isInactive":"Badge-module--isInactive--z5Thb"};